import { useEffect } from 'react';
import { devUseWarning } from '../../_util/warning';
const names = {};
export default function useFormWarning({ name }) {
    const warning = devUseWarning('Form');
    useEffect(() => {
        if (name) {
            names[name] = (names[name] || 0) + 1;
            warning(names[name] <= 1, 'usage', 'There exist multiple Form with same `name`.');
            return () => {
                names[name] -= 1;
            };
        }
    }, [name]);
}
